export const aboutIntro = {
  greeting: "Hello! I'm Paulo. 👋",
  lines: [
    "Associate Network Engineer at AT&T, working on network infrastructure",
    "B.S. in Software Engineering (Honors), Minor in Mathematics — FGCU",
    "Full stack developer & published researcher in AI, IoT, and computer networks",
  ],
};

export const aboutFacts = [{ label: "Location:", value: "Orlando, FL, USA" }];

export const aboutExperienceAreas = [
  "Network Engineering",
  "Full Stack Development",
  "Cloud Architecture",
  "Network Security",
  "AI/ML Implementation",
];
